import { render } from "./LabInformation.vue?vue&type=template&id=3c4bc13f&scoped=true"
import script from "./LabInformation.vue?vue&type=script&lang=js"
export * from "./LabInformation.vue?vue&type=script&lang=js"

import "./LabInformation.vue?vue&type=style&index=0&id=3c4bc13f&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4bc13f"],['__file',"src/components/panels/LabInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c4bc13f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c4bc13f', __exports__)) {
    console.log('reload')
    api.reload('3c4bc13f', __exports__)
  }
  
  module.hot.accept("./LabInformation.vue?vue&type=template&id=3c4bc13f&scoped=true", () => {
    console.log('re-render')
    api.rerender('3c4bc13f', render)
  })

}


export default __exports__